import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MobyDick2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MOBY_DICK2;
}

export default MobyDick2PoiTileEntity;
